module.exports = __webpack_public_path__ + "media/narrow_bumpy_space.3f891c7d.wav";